module.exports = __webpack_public_path__ + "media/images/logo-da8f183a6d2a6281abf21abc86e206ad.png";